import ScreeningAssessment, {
  ScreeningAssessmentProps,
} from "../ScreeningAssessment";
import { HOME_HEALTH_SCREENER_TYPES } from "../assessment-constant";

export type SmokingAssessmentProps = Omit<ScreeningAssessmentProps, "type">;

const SmokingAssessment = (props: SmokingAssessmentProps) => (
  <ScreeningAssessment {...props} type={HOME_HEALTH_SCREENER_TYPES.smoking} />
);

export default SmokingAssessment;
